/**
 * The default value for the `disableKeyAttributes` option
 * for the `update` function. This should be the fallback
 * value when providing options to the `build` function.
 *
 * @defaultValue true
 * @internal scope: package
 */
export const DEFAULT_DISABLE_KEY_ATTRIBUTES = true;
/**
 * @internal scope: package
 */
export function createSharedOptions(options) {
    return {
        document: options.document ?? globalThis.document,
        logger: options.logger,
        disableKeyAttributes: options.disableKeyAttributes ?? DEFAULT_DISABLE_KEY_ATTRIBUTES,
    };
}
